/**
 * MultiModelReelDisplay Component
 * Feature 017: Instagram Reel Creation
 * Dynamic 1-3 column layout for comparing AI-generated reel scripts
 */

import { memo } from 'react';
import { ReelModelColumnMemo } from './ReelModelColumn';
import type { IReelModelResponse, ModelKey } from '../../@types/reels';

interface IMultiModelReelDisplayProps {
  selectedModels: ModelKey[];
  generatedReels: Record<ModelKey, IReelModelResponse>;
  generationStatus: Record<ModelKey, 'idle' | 'loading' | 'completed' | 'error'>;
  selectedVariantModel: ModelKey | null;
  isSelecting: boolean;
  onSelectBestVariant: (modelKey: ModelKey) => Promise<void>;
}

const MultiModelReelDisplay = ({
  selectedModels,
  generatedReels,
  generationStatus,
  selectedVariantModel,
  isSelecting,
  onSelectBestVariant,
}: IMultiModelReelDisplayProps) => {
  // Dynamic grid class based on model count
  const gridClass =
    selectedModels.length === 1
      ? 'grid grid-cols-1 gap-6'
      : selectedModels.length === 2
        ? 'grid grid-cols-1 gap-6 lg:grid-cols-2'
        : 'grid grid-cols-1 gap-6 lg:grid-cols-3';

  // Helper to get model display name
  const getModelName = (modelKey: ModelKey): string => {
    if (modelKey === 'claude') return 'Claude Opus 4.6';
    if (modelKey === 'gemini') return 'Gemini 3.1 Pro';
    return 'GPT-5.4';
  };

  return (
    <div className={gridClass}>
      {selectedModels.map(modelKey => (
        <ReelModelColumnMemo
          key={modelKey}
          modelKey={modelKey}
          modelName={getModelName(modelKey)}
          reelData={generatedReels[modelKey]}
          status={generationStatus[modelKey]}
          selectedVariantModel={selectedVariantModel}
          isSelecting={isSelecting}
          onSelectBestVariant={onSelectBestVariant}
        />
      ))}
    </div>
  );
};

export const MultiModelReelDisplayMemo = memo(MultiModelReelDisplay);
